import { createApi } from '@reduxjs/toolkit/query/react'
import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query'
import { getCSRFToken } from '@view/utils/getCSRFToken'
import type { Department, BusinessUser, DepartmentView } from './services/types'

export const departmentsApi = createApi({
	reducerPath: 'departments',

	baseQuery: fetchBaseQuery({
		prepareHeaders: (headers, { type }) => {
			headers.set('x-react', 'useReact')
			if (type === 'mutation') {
				headers.set('X-CSRF-Token', getCSRFToken())
			}
			return headers
		},
		baseUrl: '/department',
	}),
	tagTypes: ['Departments', 'Department', 'Parents', 'Users', 'Vehicles', 'Vehicle', 'User', 'Parent'],
	endpoints: build => ({
		getDepartments: build.query<Department[], void>({
			query: () => `/`,
			// providesTags: result => (result ? result.map(({ id }) => ({ type: 'Departments' as const, id })) : ['Departments']),
			providesTags: ['Departments'],
		}),
		getBusinessDepartments: build.query<Department[], number | string>({
			query: businessId => `/?businessId=${businessId}`,
			// providesTags: result => (result ? result.map(({ id }) => ({ type: 'Departments' as const, id })) : ['Departments']),
			providesTags: ['Departments'],
		}),
		getParents: build.query<Department[], void>({
			query: () => `/all/`,
			providesTags: ['Parents'],
		}),
		getBusinessParents: build.query<Department[], number | string>({
			query: businessId => `/all/?businessId=${businessId}`,
			providesTags: ['Parents'],
		}),
		getDepartment: build.query<DepartmentView, { departmentId: string; businessId: string }>({
			query: ids => `/view/?departmentId=${ids.departmentId}?businessId=${ids.businessId}`,
			// providesTags: (_result, _error, id) => [{ type: 'Department' as const, id }],
			providesTags: ['Department'],
		}),
		getBusinessUsers: build.query<BusinessUser[], string>({
			query: businessId => `/get-business-users/?businessId=${businessId}`,
			providesTags: ['Users'],
		}),
		// getVehicles:build.query<>
		deleteUser: build.mutation({
			query: body => ({
				url: `/delete/user/`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Users', 'Department'],
		}),
		addUserToDepartment: build.mutation<{ status?: string; message?: string }, { userNameSearch: string; departmentId: string }>({
			query: body => ({
				url: `/user/store/`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Users', 'Department'],
		}),
		addNewDepartment: build.mutation({
			query: body => ({
				url: '/store/',
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Departments', 'Parents', 'Department'],
		}),
		addVehicle: build.mutation({
			query: body => ({
				url: `/vehicle/store/`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Departments', 'Department', 'Vehicles'],
		}),
		deleteVehicle: build.mutation({
			query: body => ({
				url: `/delete/vehicle/`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Vehicles', 'Departments', 'Department'],
		}),
	}),
})
export const {
	useGetDepartmentsQuery,
	useGetBusinessDepartmentsQuery,
	useGetBusinessUsersQuery,
	useGetDepartmentQuery,
	useGetParentsQuery,
	useGetBusinessParentsQuery,
	useAddNewDepartmentMutation,
	useAddUserToDepartmentMutation,
	useDeleteUserMutation,
	useAddVehicleMutation,
	useDeleteVehicleMutation,
} = departmentsApi
